// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PandaDocButtonDataFragmentDoc } from '../components/PandaDocUploadButton.generated';
import { DocumentEditorDetailFragmentDoc } from '../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DevelopmentCommitmentQuery = { __typename?: 'Query', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, name: string, status: Types.CommitmentStatus, statusDetail: { __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, development: { __typename?: 'Development', id: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type SavePandaDocMutationVariables = Types.Exact<{
  input: Types.SavePandaDocInput;
}>;


export type SavePandaDocMutation = { __typename?: 'Mutation', savePandaDoc: { __typename?: 'SavePandaDocResult', pandaDoc: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, developmentCommitment?: { __typename?: 'DevelopmentCommitment', id: string, status: Types.CommitmentStatus, statusDetail: { __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string } } | null | undefined } } };

export type DeleteDevelopmentCommitmentMutationVariables = Types.Exact<{
  input: Types.DeleteDevelopmentCommitmentInput;
}>;


export type DeleteDevelopmentCommitmentMutation = { __typename?: 'Mutation', deleteDevelopmentCommitment: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const DevelopmentCommitmentDocument = gql`
    query DevelopmentCommitment($id: ID!) {
  developmentCommitment(id: $id) {
    id
    name
    status
    statusDetail {
      code
      name
    }
    pandaDoc {
      ...PandaDocButtonData
      document {
        ...DocumentEditorDetail
      }
    }
    document {
      ...DocumentEditorDetail
    }
    development {
      id
    }
    canCreatePandaDoc {
      allowed
      disabledReasons {
        message
      }
    }
  }
}
    ${PandaDocButtonDataFragmentDoc}
${DocumentEditorDetailFragmentDoc}`;

/**
 * __useDevelopmentCommitmentQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDevelopmentCommitmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables> & ({ variables: DevelopmentCommitmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>(DevelopmentCommitmentDocument, options);
      }
export function useDevelopmentCommitmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>(DevelopmentCommitmentDocument, options);
        }
// @ts-ignore
export function useDevelopmentCommitmentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>;
export function useDevelopmentCommitmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentQuery | undefined, DevelopmentCommitmentQueryVariables>;
export function useDevelopmentCommitmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>(DevelopmentCommitmentDocument, options);
        }
export type DevelopmentCommitmentQueryHookResult = ReturnType<typeof useDevelopmentCommitmentQuery>;
export type DevelopmentCommitmentLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentLazyQuery>;
export type DevelopmentCommitmentSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentSuspenseQuery>;
export type DevelopmentCommitmentQueryResult = ApolloReactCommon.QueryResult<DevelopmentCommitmentQuery, DevelopmentCommitmentQueryVariables>;
export const SavePandaDocDocument = gql`
    mutation SavePandaDoc($input: SavePandaDocInput!) {
  savePandaDoc(input: $input) {
    pandaDoc {
      ...PandaDocButtonData
      developmentCommitment {
        id
        status
        statusDetail {
          code
          name
        }
      }
    }
  }
}
    ${PandaDocButtonDataFragmentDoc}`;

/**
 * __useSavePandaDocMutation__
 *
 * To run a mutation, you first call `useSavePandaDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePandaDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePandaDocMutation, { data, loading, error }] = useSavePandaDocMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePandaDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePandaDocMutation, SavePandaDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePandaDocMutation, SavePandaDocMutationVariables>(SavePandaDocDocument, options);
      }
export type SavePandaDocMutationHookResult = ReturnType<typeof useSavePandaDocMutation>;
export type SavePandaDocMutationResult = ApolloReactCommon.MutationResult<SavePandaDocMutation>;
export const DeleteDevelopmentCommitmentDocument = gql`
    mutation DeleteDevelopmentCommitment($input: DeleteDevelopmentCommitmentInput!) {
  deleteDevelopmentCommitment(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteDevelopmentCommitmentMutation__
 *
 * To run a mutation, you first call `useDeleteDevelopmentCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDevelopmentCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDevelopmentCommitmentMutation, { data, loading, error }] = useDeleteDevelopmentCommitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDevelopmentCommitmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDevelopmentCommitmentMutation, DeleteDevelopmentCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDevelopmentCommitmentMutation, DeleteDevelopmentCommitmentMutationVariables>(DeleteDevelopmentCommitmentDocument, options);
      }
export type DeleteDevelopmentCommitmentMutationHookResult = ReturnType<typeof useDeleteDevelopmentCommitmentMutation>;
export type DeleteDevelopmentCommitmentMutationResult = ApolloReactCommon.MutationResult<DeleteDevelopmentCommitmentMutation>;